const additionalSampleId = '49794690580821';
const freeCandleId = '50078135091541';
const freeCandlePrice = "1000000";
const bagVariantId = '50647929061717';

const bindGiftWrapperEvent = async () => {
  const giftWrappingForm = document.querySelector('.checkbox-wrapper')

  const cartItems = (await ShopifyApi.getCartItems()).items

  if (cartItems.find(item => item.properties._attach_addtional_sample)) {
    giftWrappingForm.classList.remove('hidden')
  }

  document.querySelector('#gift-wrapping')?.addEventListener('change', function (event) {
    const checkoutButton = document.querySelector('button[name="checkout"]');
    checkoutButton.disabled = true;

    ShopifyApi.updateCartAttributes({ gift_wrapping: event.target.checked ? 1 : 0 })
      .then(async function () {
        if (event.target.checked) {
          const cart = await ShopifyApi.getCartItems();
          const product = {
            id: bagVariantId,
            quantity: 1,
            properties: {
              _is_free_bag: true,
            },
          };

          if (cart.items.find(item => item.id == bagVariantId)) {
            ShopifyApi.updateCartQuantity({ [bagVariantId]: 1 })
          } else {
            ShopifyApi.addToCart([product])
              .then(function () {
                refreshCart();
              })
            .finally(function () {
                checkoutButton.disabled = false;
              });
          }
        } else {
          ShopifyApi.updateCartQuantity({ [bagVariantId]: 0 })
            .then(function () {
              refreshCart();
            })
            .finally(function () {
              checkoutButton.disabled = false;
            });
        }
      })
      .finally(function () {
        setTimeout(function () {
          checkoutButton.disabled = false;
        }, 1000);
      });
  });
}

function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
}

function closeCartDrawer() {
  document.querySelector(".cart-drawer").classList.remove("cart-drawer--active");
}

const updateCartItemCounts = async () => {
  const cart = await ShopifyApi.getCartItems();
  let cartItemCount = 0

  for(let i = 0; i < cart.items.length; i ++) {
    const item = cart.items[i]

    if ((item.properties._is_additional_sample || item.properties._is_sample || item.properties._is_free_candle) && item.final_price === 0) {
      continue
    }

    cartItemCount += item.quantity
  }

  document.querySelectorAll(".cart-count").forEach((el) => {
    if (cartItemCount === 0) {
      el.textContent = ""

      return
    }

    if (el.textContent[0] === '(') {
      el.textContent = '(' + cartItemCount + ')';
    } else if (el.textContent === '') {
      if (el.classList.contains('mobile-cart-count')) {
        el.textContent =  cartItemCount
      } else {
        el.textContent = '(' + cartItemCount + ')';
      }
    } else {
      el.textContent = cartItemCount;
    }
  });
}

async function updateCartDrawer() {
  const drawer = document.querySelector(".cart-drawer")

  if (!drawer) {
    return
  }

  const res = await fetch(getLocale() + "/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;

  drawer.innerHTML = newBox;

  addCartDrawerListeners();
}

async function updateCartPage() {
  const res = await fetch(getLocale() + "/?section_id=cart");
  const text = await res.text();

  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html
    .querySelector(".cart-page")
    .innerHTML

  document
    .querySelector(".cart-page")
    .innerHTML = newBox;

  addCartDrawerListeners();
}

function addCartDrawerListeners() {
  document.querySelectorAll(".cart-drawer-quantity-selector button").forEach((button) => {
    button.addEventListener("click", async () => {
      const key = button.dataset.itemKey;
      const sampleId = button.dataset.sampleId

      // Get new quantity
      const currentQuantity = Number(button.parentElement.querySelector("input").value);
      const isUp = button.classList.contains("cart-drawer-quantity-selector-plus");
      const newQuantity = isUp
        ? currentQuantity + 1
        : currentQuantity - 1;

      try {
        addLoadingAnimation([button])
        await updateCartQuantity(key, newQuantity, sampleId)
      } catch (e) {
        console.error(e)
      } finally {
        removeLoadingAnimation([button])
      }
    });
  });

  document.querySelectorAll(".cart-drawer-header-right-close, .cart-drawer-overlay").forEach((el) => {
    el.addEventListener("click", closeCartDrawer);
  });

  // bindGiftWrapperEvent();
}

const checkIfNeedRemoveSample = (items, sampleId) => {
  const countByProductId = {}
  let sample;

  items.forEach(item => {
    if (item.id == sampleId) {
      sample = item
    } 

    if (item.price < 1) {
      return
    }

    if (!countByProductId[item.product_id]) {
      countByProductId[item.product_id] = 0
    }
    countByProductId[item.product_id] ++
  })

  const updates = {}

  // Remove related sample product if sample in the cart and only have this single product in the cart
  if (sample && countByProductId[sample.product_id] === 1) {
    updates[sampleId] = 0
  }

  return updates;
}

const changeAdditionalSample = async (select, index = 1) => {
  try {
    addLoadingAnimation([select])

    const cart = await ShopifyApi.getCartItems();

    const [name, sku] = select.value.split('||')

    const item = cart.items.find(item => item.id == additionalSampleId)

    const properties = item.properties

    properties["Product " + index] = name
    properties["_SKU " + index] = sku

    await ShopifyApi.updateCartItem({ id: additionalSampleId, properties })
  } catch (e) {
    console.error(e)
  } finally {
    removeLoadingAnimation([select])
  }
}

const checkSampleRules = async () => {
  const cart = await ShopifyApi.getCartItems();

  const items = []
  let toRemove = {}

  // Check if need to add additional sample
  let needToAddAdditionSample = false
  let hasAdditionalSample = false

  cart.items.forEach(item => {
    if (item.properties._is_additional_sample) {
      hasAdditionalSample = true
    }

    if (item.properties._attach_addtional_sample) {
      needToAddAdditionSample = true
    }
  })

  if (needToAddAdditionSample && !hasAdditionalSample) {
    items.push({
      id: additionalSampleId,
      quantity: 1,
      properties: { _is_additional_sample: true }
    })
  }

  if (!needToAddAdditionSample && hasAdditionalSample) {
    toRemove[additionalSampleId] = 0
  }

  // Check if need to add free candle
  const freeCandle = cart.items.find(item => item.id == freeCandleId)

  if (!freeCandle && cart.total_price >= freeCandlePrice) {
    items.push({
      id: freeCandleId,
      quantity: 1,
      properties: { _is_free_candle: true }
    })
  }

  if (freeCandle && cart.total_price < freeCandlePrice) {
    toRemove[freeCandleId] = 0
  }

  // Add necessary sample
  if (items.length > 0) {
    await ShopifyApi.addToCart(items) 
  }

  // Remove unnecessary samples
  if (Object.keys(toRemove).length > 0) {
    await ShopifyApi.updateCartQuantity(toRemove)
  }
}

const refreshCart = async () => {
  updateCartItemCounts();

  if (document.querySelector(".cart-page")) {
    await updateCartPage();
  } else {
    await updateCartDrawer();
  }
}

const updateCartQuantity = async (key, newQuantity, sampleId) => {
  const cart = await ShopifyApi.getCartItems();

  let updates = { [key]: newQuantity }

  if (newQuantity === 0) {
    updates = {...updates, ...checkIfNeedRemoveSample(cart.items, sampleId)}
  }

  await ShopifyApi.updateCartQuantity(updates)

  setTimeout(async () => {
    await checkSampleRules(cart.items);
    refreshCart();
  }, 200)
}

const addToCartWithSamples = async (form) => {
  const formButtons = form.querySelectorAll('button[type="submit"], input[type="submit"]')
  const formData = new FormData(form)
  const cart = await ShopifyApi.getCartItems();

  const product = {
    id: formData.get('id'),
    quantity: 1,
    properties: {}
  }

  if (formData.get('properties[Recipient email]')) {
    product.properties['Recipient email'] = formData.get('properties[Recipient email]')
    product.properties['Recipient name'] = formData.get('properties[Recipient name]')
    product.properties['Message'] = formData.get('properties[Message]')
    product.properties.__shopify_send_gift_card_to_recipient = "on"
  }

  if (formData.get('properties[should_attach_additional_sample]')) {
    product.properties._attach_addtional_sample = true
  }

  const items = [product]

  if (formData.get('properties[_is_sample]')) {
    product.properties['_is_sample'] = true
  } else {
    // Check if is bundled product
    const bundleIds = formData.get('bundle_ids')
    if (bundleIds) {
      const selections = bundleIds.split(',')?.map((id) => document.getElementById(id).value)

      selections.map((id, index) => {
        const [title, sku, barcode] = id.split('||')

        product.properties["Product " + (index+1)] = title
        product.properties["_SKU " + (index+1)] = sku
      })
    }

    // Check if need to add related sample product
    const sampleId = formData.get('properties[sample]')

    // build the form

    if (sampleId) {
      product.properties._sample_id = sampleId

      const sample = cart.items.find(item => item.id == sampleId)

      // if sample doesn't exists in cart
      if (!sample) {
        items.push({
          id: sampleId,
          quantity: 1,
          properties: { _is_sample: true }
        })
      }
    }

    // Check if need to add additional sample product
    const additionalSample = cart.items.find(item => item.id == additionalSampleId)

    if (!additionalSample && product.properties._attach_addtional_sample) {
      items.push({
        id: additionalSampleId,
        quantity: 1,
        properties: { _is_additional_sample: true }
      })
    }

    // Check if need to add free candle
    const freeCandle = cart.items.find(item => item.id == freeCandleId)

    const idPrice = formData.getAll('prices[]').find(idPrice => idPrice.split('_')[0] === formData.get('id'))

    const price = idPrice?.split('_')?.[1] ?? 0
    const totalAmount = cart.total_price + parseInt(price)

    if (!freeCandle && totalAmount >= freeCandlePrice) {
      items.push({
        id: freeCandleId,
        quantity: 1,
        properties: { _is_free_candle: true }
      })
    }
  }

  try {
    addLoadingAnimation(formButtons)
    await ShopifyApi.addToCart(items) 

  } catch (e) {
    // toast display error
    console.log(e)
    return cart.item_count
  } finally {
    removeLoadingAnimation(formButtons)
  }

  return cart.item_count + 1
}

const removeCartItem = async (button, key, sampleId) => {
  try {
    addLoadingAnimation([button])
    await updateCartQuantity(key, 0, sampleId)
  } catch (e) {
    console.error(e)
  } finally {
    removeLoadingAnimation([button])
  }
}

document.addEventListener("DOMContentLoaded", function() {
  addCartDrawerListeners();
  document.querySelectorAll('.product-form').forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
  
      await addToCartWithSamples(form)
  
      await refreshCart();
  
      openCartDrawer();
    });
  });

  document.querySelector('#has-gift-message')?.addEventListener('change', async function (event) {
    const hasMessage = event.target.checked;
    const giftMessageWrapper = document.querySelector('#gift-message-wrapper');

    if (hasMessage) {
      giftMessageWrapper.classList.remove('opacity-0');
    } else {
      giftMessageWrapper.classList.add('opacity-0');
    }

    await ShopifyApi.updateCartAttributes({ has_gift_message: hasMessage ? 1 : 0 });
  });

  document.querySelector('#gift-message')?.addEventListener('change', async function (event) {
    await ShopifyApi.updateCartAttributes({ gift_message: event.target.value });
  });
});